import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface StatCardProps {
  icon?: React.ReactNode;
  label: string;
  value: string | number;
  sub?: string;
  className?: string;
}

export default function StatCard({ icon, label, value, sub, className = '' }: StatCardProps) {
  return (
    <Card className={className}>
      <CardContent className="p-3 flex items-center gap-3">
        {icon}
        <div>
          <div className="text-lg font-bold leading-none">{value}</div>
          <div className="text-xs text-muted-foreground">{label}</div>
          {sub && (
            <div className="text-xs text-muted-foreground truncate max-w-[120px]">{sub}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
